import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "row g-5" }
const _hoisted_2 = { class: "card border border-dashed rounded border-2 border-info" }
const _hoisted_3 = { class: "card-body py-3" }
const _hoisted_4 = { class: "d-flex align-items-center" }
const _hoisted_5 = { class: "fs-2 fw-bold" }
const _hoisted_6 = { class: "fw-semibol fs-7" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.itemsList, (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "col-6"
      }, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (item.params)
                ? (_openBlock(), _createElementBlock("i", {
                    key: 0,
                    class: _normalizeClass(`${item.params} fs-1 me-2`)
                  }, null, 2))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_5, _toDisplayString(item.quantity), 1)
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(item.name), 1)
          ])
        ])
      ]))
    }), 128))
  ]))
}